import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.scrollToActive();
  }

  scrollToActive() {
    const activeItem = this.element.querySelector('[data-active="true"]');
    if (activeItem) {
      activeItem.scrollIntoView({ behavior: "smooth", block: "nearest", inline: "center" });
    }
  }
}
